export const MAX_MODULES = 7;
export const MPE_SEMESTER: 1 | 2 = 2;
export const MPE_AY = '2026/2027';
export const CPEX_FAQ_URL = 'https://www.nus.edu.sg/registrar/docs/info/cpex/cpex-faqs.pdf';
